import React from "react";
import { twMerge } from "tailwind-merge";

type Props = React.ComponentPropsWithoutRef<"p"> & {
  error?: unknown;
  className?: string;
  center?: boolean;
};

export default function ErrorText({ className, error, ...rest }: Props) {
  const cn = twMerge(
    "text-xs italic text-red-500",
    className,
    rest.center ? "text-center" : "",
  );

  if (error && error instanceof Error) {
    return (
      <p className={cn} {...rest}>
        {error.message}
      </p>
    );
  }

  if (typeof error === "string") {
    return (
      <p className={cn} {...rest}>
        {error}
      </p>
    );
  }

  return <p className={cn} {...rest} />;
}
